import { graphql } from '@/gql'

export default graphql(`
  query getEmployee($graphileIdRequired: UUID!) {
    employeeById(id: $graphileIdRequired) {
      ...EmployeeProfile
    }
  }
`)

export const EMPLOYEE_QUERY = graphql(`
  query employeeQuery($id: UUID!) {
    employeeById(id: $id) {
      id
      departments
      isArchived
      formFieldEntries(condition: { active: true }) {
        edges {
          node {
            ...FormFieldEntry
          }
        }
      }
      user {
        id
        firstName
        lastName
        initials
        alternateFirstName
        alternateLastName
        fullName
        email
        emailWork
        mobile
        phone
        employmentStart
        employmentEnd
        seniority
        employeeNumber
        employmentJurisdiction
        birthdate
        address
        postalCode
        city
        country
        mobilePrivate
        locale
        cpr
        bankRegistrationNumber
        bankAccountNumber
        logo
        hasLogo
        jobPositionTitle
        jobPositionType
        jobPositionWorkingHours
        jobPositionDescription
        directManager {
          id
          employeeId
          firstName
          lastName
          fullName
        }
        userDepartments(filter: { department: { active: { equalTo: true } } }) {
          nodes {
            departmentId
            department {
              id
              name
            }
          }
        }
      }
    }
  }
`)

export const EMPLOYEE_EQUIPMENT = graphql(`
  query getEmployeeEquipment(
    $id: UUID!
    $filter: EquipmentFilter
    $orderBy: [EquipmentOrderBy!]
  ) {
    employeeById(id: $id) {
      id
      userId
      equipments(orderBy: $orderBy, filter: $filter) {
        edges {
          node {
            id
            startDate
            createdAt

            product {
              id
              name
              description
              serial
              productType {
                id
                name
                localizedName
              }
              productTypeId
              storages {
                nodes {
                  id
                  filename
                  fileExtension
                }
              }
              formFieldEntries(condition: { active: true }) {
                nodes {
                  value
                  formFieldId
                  formField {
                    fieldType
                    metadata
                    productTypeIds
                    formFieldOptions {
                      nodes {
                        id
                        localizedValue
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`)

export const EMPLOYEE_TASKS = graphql(`
  query employeeTasks(
    $filter: TaskFilter
    $after: Cursor
    $first: Int
    $includeRelations: Boolean!
  ) {
    tasks(
      orderBy: ORDER_ASC
      condition: { active: true }
      filter: $filter
      after: $after
      first: $first
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Task
          process @include(if: $includeRelations) {
            id
            name
            active
          }
          project @include(if: $includeRelations) {
            id
            name
            order
            active
            process {
              id
              name
              active
            }
          }
        }
      }
    }
  }
`)

export const GET_BULK_EDIT_EMPLOYEES_VALUES = graphql(`
  query getBulkEditEmployeeValues(
    $formFieldIds: [UUID!]
    $departmentIds: [UUID!]
    $userIds: [UUID!]
    $systemFieldNames: [String!]
  ) {
    formFields(filter: { id: { in: $formFieldIds } }) {
      nodes {
        ...FormField
      }
    }

    departments(filter: { id: { in: $departmentIds } }) {
      nodes {
        id
        name
      }
    }

    users(filter: { id: { in: $userIds } }) {
      nodes {
        id
        fullName
        logo
      }
    }

    systemFields(filter: { name: { in: $systemFieldNames } }) {
      nodes {
        id
        name
        companySystemField {
          id
          companySystemFieldOptions(condition: { active: true }) {
            nodes {
              id
              value
              localizedValue
            }
          }
        }
      }
    }
  }
`)

export const TRY_GET_EMPLOYEE = graphql(`
  query tryGetEmployee($id: UUID!) {
    employeeById(id: $id) {
      id
    }
  }
`)

export const LOGGED_IN_EMPLOYEE_QUERY = graphql(`
  query loggedInEmployee($id: UUID!) {
    userById(id: $id) {
      id
      employeeId
      locale
      logo
      firstName
      lastName
      fullName
      email
      phone
      mobile
      address
      city
      birthdate
      cpr
      bankAccountNumber
      bankRegistrationNumber
      companyAdmin
      jobPositionTitle
      jobPositionType
      departments
      company {
        id
        name
        locale
        logo
        sso
        availableLocales
        nativeAppAccess
      }
    }
  }
`)
